import { actions, subjects } from '~/composables/useRolePermissions'

export const routePermissions = {
  // Dashboard
  dashboard: [actions.VIEW, subjects.DASHBOARD],

  // Users
  usersList: [actions.LIST, subjects.USERS],
  userCreate: [actions.CREATE, subjects.USERS],
  userEdit: [actions.EDIT, subjects.USERS],
  userView: [actions.VIEW, subjects.USERS],

  // Companies
  companiesList: [actions.LIST, subjects.COMPANIES],
  companyCreate: [actions.CREATE, subjects.COMPANIES],
  companyEdit: [actions.EDIT, subjects.COMPANIES],
  companyView: [actions.VIEW, subjects.COMPANIES],

  // Invitations
  invitationsList: [actions.LIST, subjects.USER_INVITATION],

  // Product Items
  productItemsList: [actions.LIST, subjects.PRODUCT_ITEMS],
  productItemCreate: [actions.CREATE, subjects.PRODUCT_ITEMS],
  productItemEdit: [actions.EDIT, subjects.PRODUCT_ITEMS],
  productItemView: [actions.VIEW, subjects.PRODUCT_ITEMS],

  // Promotions
  promotionsList: [actions.LIST, subjects.PROMOTIONS],
  promotionView: [actions.VIEW, subjects.PROMOTIONS],
  promotionCreate: [actions.CREATE, subjects.PROMOTIONS],
  promotionConfig: [actions.VIEW, subjects.PROMOTION_CONFIG],

  // Promotion sub-routes
  budgetList: [actions.LIST, subjects.BUDGET],
  fileList: [actions.LIST, subjects.FILE],
  messageList: [actions.LIST, subjects.MESSAGE],
  offersList: [actions.LIST, subjects.BUDGET_QUOTE],
  contractList: [actions.LIST, subjects.CONTRACTS],
  simulationsList: [actions.LIST, subjects.SIMULATIONS],
  simulationView: [actions.VIEW, subjects.SIMULATIONS],
}
